import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { getMonthlySalesPromotionInfo, getYearlySalesPromotionInfo} from "../../../actions/salesDashboard";
import { getCurrentPetShop } from "../../../actions/petShop";
import { NavLink } from "react-router-dom";
import _ from "lodash";
import { NotificationManager } from "react-notifications";
import { forceInputUppercase } from "../../../utils/helper";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import filterFactory, {
  textFilter,
  selectFilter,
} from "react-bootstrap-table2-filter";
import Select from "react-select";
import { Loader } from "../../../components/loader";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import moment from "moment";
import config from "../../../config";
const $ = window.$;

const BarChart = require("react-chartjs").Bar;
const HEADERCOLUMN = {
  category : "Category",
  source : "Source",
  contractCount : "totalContractCount",
  isUtmData : "isUtmData",
  utmData : "utmData",
}
const intialState = {
  mRecCount: 0,
  contCount: 0,
  pTreatments: 0,
  oTreatments: 0,
  trmntsOnGoing: [],
  trmntsPending: [],
  mRecords: [],
  allmRecords: [],
  contracts: [],
  treatId: "",
  chartOptions: {
    responsive: true,
    legend: {
      position: "top",
    },
    title: {
      display: true,
      text: "Total sales from 2018-04-10 to 2018-05-10",
    },
  },
  userLogins: [],
  petId: "",
  email: "",
  validateFlag: false,
  verifyEmail: [],
  verifyEmailId: "",
  successEmail: false,
  salesSelectOption: [],
  customersStatesTableSelectOptions: [
    { label: "All Time", value: "all", startDate: "all" },
  ],
  salesSelectOptionYearly : [],
  monthlyCount: 0,
  monthlyTax: 0,
  monthlyTotal: 0,
  monthlyCDTotal: 0,
  monthlyCashTotal: 0,
  monthlyOtherTotal: 0,
  monthlyFinanceTotal: 0,
  chartmonthlyData: {
    labels: [],
    datasets: [
      {
        label: "Total (USD)",
        fillColor: "rgb(255, 177, 193,0.5)",
        strokeColor: "rgb(255, 177, 193)",
        highlightFill: "rgb(255, 177, 193,0.5)",
        highlightStroke: "rgb(255, 177, 193)",
        borderWidth: 1,
        data: [],
      },
    ],
  },
  ContractsViaCustomersState: [],
  ContractsAllDataViaCustomersState: [],
  loadingContractViaStateTable: false,
  enableMoreText: false,
  monthlyDataLoading: false,
  saleTitle: "",
  breedSalesData: [],
  sourceOfSalesData: [],
  sourceOfSalesDetailsContract: [],
  selectedSourceName: "",
  salesSelectedOptionYearly:"LAST12MONTH",
  salesInformationAmountData:[],
  contractCountDataYearly:[],
  salesSelectedOptionYearlyTimeFrameType : "LAST_6MONTH",
  tableHeadersalesInformationAmountData : [
         {
          dataField: "Category",
          text: "Category",
          sort: true
        },
        {
          dataField: "Jan",
          text: "Jan",
          sort: true
        },
        {
          dataField: "Feb",
          text: "Feb",
          sort: true
        },
        {
          dataField: "Mar",
          text: "Mar",
          sort: true
        },
        {
          dataField: "Apr",
          text: "Apr",
          sort: true
        },
        {
          dataField: "May",
          text: "May",
          sort: true
        },
        {
          dataField: "Jun",
          text: "Jun",
          sort: true
        },
        {
          dataField: "Jul",
          text: "Jul",
          sort: true
        },
        {
          dataField: "Aug",
          text: "Aug",
          sort: true
        },
        {
          dataField: "Sep",
          text: "Sep",
          sort: true
        },
        {
          dataField: "Oct",
          text: "Oct",
          sort: true
        },
        {
          dataField: "Nov",
          text: "Nov",
          sort: true
        },
        {
          dataField: "Dec",
          text : "Dec",
          sort : true
        },
        {
          dataFieldb: "Avg",
          text : "Avg",
          sort : true
  }],
  tableHeadercontractCountDataYearly : [
    {
        dataField: "totalContractCount",
        text: "Total Sales",
        sort: true
      },
      {
        dataField: "Location",
        text: "Location",
        sort: true
      },
      {
        dataField: "Jan",
        text: "Jan",
        sort: true
      },
      {
        dataField: "Feb",
        text: "Feb",
        sort: true
      },
      {
        dataField: "Mar",
        text: "Mar",
        sort: true
      },
      {
        dataField: "Apr",
        text: "Apr",
        sort: true
      },
      {
        dataField: "May",
        text: "May",
        sort: true
      },
      {
        dataField: "Jun",
        text: "Jun",
        sort: true
      },
      {
        dataField: "Jul",
        text: "Jul",
        sort: true
      },
      {
        dataField: "Aug",
        text: "Aug",
        sort: true
      },
      {
        dataField: "Sep",
        text: "Sep",
        sort: true
      },
      {
        dataField: "Oct",
        text: "Oct",
        sort: true
      },
      {
        dataField: "Nov",
        text: "Nov",
        sort: true
      },
      {
        dataField: "Dec",
        text: "Dec",
        sort: true
      }
  ],
  loadingYearlyData : false,
  tableHeaderWeeklySalesCount : [
    { dataField : "Week1", text : "Week 1", sort : true, align : "right"},
    { dataField : "Week2", text : "Week 2", sort : true},
    { dataField : "Week3", text : "Week 3", sort : true},
    { dataField : "Week4", text : "Week 4", sort : true}
  ],

  tableHeaderWeeklySalesCountData : [{ Week1 : 0, Week2 : 0, Week3 : 0, Week4 : 0 }],
  sourceOfSalesDataYearly : [],
  tableHeaderSourceOfSales : [    
  {
    dataField: "Source",
    text: "Source",
    sort: true
  },
  {
    dataField: "Jan",
    text: "Jan",
    sort: true
  },
  {
    dataField: "Feb",
    text: "Feb",
    sort: true
  },
  {
    dataField: "Mar",
    text: "Mar",
    sort: true
  },
  {
    dataField: "Apr",
    text: "Apr",
    sort: true
  },
  {
    dataField: "May",
    text: "May",
    sort: true
  },
  {
    dataField: "Jun",
    text: "Jun",
    sort: true
  },
  {
    dataField: "Jul",
    text: "Jul",
    sort: true
  },
  {
    dataField: "Aug",
    text: "Aug",
    sort: true
  },
  {
    dataField: "Sep",
    text: "Sep",
    sort: true
  },
  {
    dataField: "Oct",
    text: "Oct",
    sort: true
  },
  {
    dataField: "Nov",
    text: "Nov",
    sort: true
  },
  {
    dataField: "Dec",
    text: "Dec",
    sort: true
  }],
  sourceOfSalesYearlyDetailsContract : [],
  selectedSourceYearly : '',

};

class AdminDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = intialState;
  }
  paymentType = {
    credit_debit: "credit_debit",
    other: "other",
    cash: "Cash",
    finance: "Financing",
    american_express: "American Express",
    discover: "DISCOVER",
  };
  contractInfoLimitation = 5;

  tableHeaderColumnData = [
    {
      dataField: "state",
      text: "State",
      sort: true,
    },
    {
      dataField: "contractCount",
      text: "Count",
      sort: true,
      formatter: (cell) => cell,
    },
  ];

  tableHeaderbreedSalesData = [
    {
      dataField: "breed",
      text: "Name",
      sort: true,
    },
    {
      dataField: "contractCount",
      text: "Count",
      sort: true,
      align: "right",
      formatter: (cell) => cell,
      headerStyle: () => {
        return { width: "65px", textAlign: "center" };
      }
    },
  ];

  tableHeaderSalesOfSourceData = [
    {
      dataField: "findUs",
      text: "Name",
      sort: true,
      formatter: (cell, row) => {
        return (
          <>
          <a
            onClick={(e) => {
              this.openSourceOfSalesDetailModal(e, row);
            }}
            style={{ cursor: "pointer", color: "#5867dd", fontWeight: "600" }}
          >
            {cell}
          </a>
          <span className="ml-2"></span>
          { row.isUtmSource &&        
          <span className="m-badge mx-auto my-0 px-1 m-badge--info">
            <strong><small>UTM</small></strong> 
          </span>          
          } 
          </>
        );
      },
    },
    {
      dataField: "contractCount",
      text: "Count",
      sort: true,
      align: "right",
      formatter: (cell) => cell,
      headerStyle: () => {
        return { width: "65px", textAlign: "center" };
      }
    },
  ];

  tableHeaderSourceOfSalesDetailColumnData = [
    {
      dataField: "utm_id",
      text: "ID",
      sort: true,
      formatter: (cell) => cell,
    },
    {
      dataField: "utm_campaign",
      text: "Campaign",
      sort: true,
      formatter: (cell) => cell,
    },
    {
      dataField: "utm_medium",
      text: "Medium",
      sort: true,
      formatter: (cell) => cell,
    },
    {
      dataField: "utm_term",
      text: "Term",
      sort: true,
      formatter: (cell) => cell,
    },
  ];

  changeSalesOption = (selected) => {
    if (selected) {
      this.setState({
        saleSelectedOption: selected.value,
        monthlyDataLoading: true,
        saleTitle: selected.title,
      });   
      this.props.getMonthlySalesPromotionInfo(selected.startDate);
    }
  };

  changeSalesOptionYearly = (selected) => {
    if(selected){     
        this.setState({ salesSelectedOptionYearly : selected.value, salesSelectedOptionYearlyTimeFrameType : selected.type, loadingYearlyData : true  });
        this.props.getYearlySalesPromotionInfo( selected.type ,selected.startDate); 
    }  
  }

  changeCustomersStateSelectOption = (selected) => { 
    if (selected) {
      this.setState({
        customerSelectOption: selected.value,
        loadingContractViaStateTable: true, 
      });
      this.props.getContractsViaCustomerState(selected.startDate);
    }
  };

  loadSalesInfo = () => {
    let monthArray = [];
    const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
    const currentMonthStartDate = moment().startOf("month").format("MMM-YYYY");
    const defaulltSaleTitle = `${moment().format("MMMM")} ${moment().format("YYYY")}`;
    let customerStateCurrentData = this.state.customersStatesTableSelectOptions;
    for (let i = 0; i <= 12; i++) {
      let monthFormat1 = moment().subtract(i, "months").format("MM");
      let monthFormat2 = moment().subtract(i, "months").format("MMM");
      let monthFormat3 = moment().subtract(i, "months").format("YYYY");
      let monthFormat4 = moment().subtract(i, "months").format("MMMM");
      monthArray.push({
        label: `${monthFormat4} ${monthFormat3}`,
        value: `${monthFormat2}-${monthFormat3}`,
        title: `${monthFormat4} ${monthFormat3}`,
        startDate: `${monthFormat3}-${monthFormat1}-01`,
      });
    }
    let fullCustomersStateOptions = monthArray.concat(customerStateCurrentData);
    this.setState({
      salesSelectOption: monthArray,
      saleSelectedOption: currentMonthStartDate,
      monthlyDataLoading: true,
      saleTitle: defaulltSaleTitle,
      customersStatesTableSelectOptions: fullCustomersStateOptions,
    });
    this.props.getMonthlySalesPromotionInfo(startOfMonth);
  };

  loadSalesSelectionDataYearly = () => {
    let yearlySelectionData = [];   
    const lastSixMonthStartMonth = moment().subtract(6,"month").format("YYYY-MM");
    const lastTwelveMonthStartMonth = moment().subtract(11,"month").format("YYYY-MM");
    yearlySelectionData.push( 
        {
        label: `LAST 12 MONTH`,
        value: `LAST12MONTH`,
        type : 'LAST_12MONTH',      
        startDate: `${lastTwelveMonthStartMonth}-01`,
        },
    );
    for (let i = 0; i < 5; i++) { 
      let year = moment().subtract(i, "years").format("YYYY");
      yearlySelectionData.push({
        id : i+1,
        label: `${year}`,
        value: `${year}`,
        type : 'FULL_YEAR',      
        startDate: `${year}-01-01`,
      });
    }

    this.setState({
      salesSelectOptionYearly: yearlySelectionData, loadingYearlyData : true
    });
    //Default loading 6 months data
    let defaultStartDate = `${lastTwelveMonthStartMonth}-01`; 
    this.props.getYearlySalesPromotionInfo( 'LAST_12MONTH', defaultStartDate); 
  };

  resetState = () => {
    const chartmonthlyData = {
      labels: ["Week1", "Week2", "Week3", "Week4"],
      datasets: [
        {
          label: "Total (USD)",
          fillColor: "rgb(255, 177, 193,0.5)",
          strokeColor: "rgb(255, 177, 193)",
          highlightFill: "rgb(255, 177, 193,0.5)",
          highlightStroke: "rgb(255, 177, 193)",
          borderWidth: 1,
          data: [0, 0, 0, 0],
        },
      ],
    };
    this.setState({
      monthlyCount: 0,
      monthlyTax: 0,
      monthlyTotal: 0,
      monthlyCDTotal: 0,
      monthlyCashTotal: 0,
      monthlyOtherTotal: 0,
      monthlyFinanceTotal: 0,
      chartmonthlyData: chartmonthlyData,
      monthlyDataLoading: false,
      salesLocationFullData: [],
      tableHeaderWeeklySalesCount : [
        { dataField : "Week1", text : "Week 1", sort : true, align : "right",
         headerStyle: () => {
          return {  textAlign: "center" };
         } 
        },
        { dataField : "Week2", text : "Week 2", sort : true, align : "right",
        headerStyle: () => {
          return {  textAlign: "center" };
         } 
        },
        { dataField : "Week3", text : "Week 3", sort : true, align : "right",
        headerStyle: () => {
          return {  textAlign: "center" };
         } 
        },
        { dataField : "Week4", text : "Week 4", sort : true, align : "right",
        headerStyle: () => {
          return {  textAlign: "center" };
         } 
        },
      ],
    
      tableHeaderWeeklySalesCountData : [{ Week1 : 0, Week2 : 0, Week3 : 0, Week4 : 0 }],
    });
  };

  openSourceOfSalesDetailModal = (e, row) => {
    e.preventDefault(); 
    let utmDataArray = [];
    const selectedSource = row.findUs ? row.findUs : "";
    this.setState({ selectedSource: selectedSource });
    const contracts = row.contracts;
    if (row && row.contracts && row.contracts.length > 0) {
      for (const contract of contracts) {
        if (contract.utmData) {
          utmDataArray.push(contract.utmData);
        }
      }
    } else {
      NotificationManager.warning("Contracts data not found");
    }
    if (utmDataArray && utmDataArray.length > 0) {
      this.setState({ sourceOfSalesDetailsContract: utmDataArray });
      $("#full_details_source_of_sale_modal").modal("show");
    } else {
      NotificationManager.warning("Contracts order id not found in source");
    }
  };

  openSourceOfSalesYearlyDetailModal = (e, row) => {
    e.preventDefault(); 
    if(row && row.utmData && row.utmData.length > 0){
      this.setState({ sourceOfSalesYearlyDetailsContract: row.utmData, selectedSourceYearly : row.Source  });
      $("#full_details_yearly_source_of_sale_modal").modal("show");      
    }else{
      NotificationManager.warning("Contracts utm source data not found");
    }
  };

  formatCash = (n) => {
    if (n < 1e3) return n;
    if (n >= 1e3 && n < 1e6) return +(n / 1e3).toFixed(1) + "K";
    if (n >= 1e6 && n < 1e9) return +(n / 1e6).toFixed(1) + "M";
    if (n >= 1e9 && n < 1e12) return +(n / 1e9).toFixed(1) + "B";
    if (n >= 1e12) return +(n / 1e12).toFixed(1) + "T";
  };

  componentDidMount() {
    this.loadSalesInfo();
    this.loadSalesSelectionDataYearly();
  }

  componentWillReceiveProps = (nextProps) => {
    if (
      this.props.contractsMonthlySalesData !==
      nextProps.contractsMonthlySalesData
    ) {
      let locationData =
        nextProps.contractsMonthlySalesData &&
        nextProps.contractsMonthlySalesData.locationState
          ? nextProps.contractsMonthlySalesData.locationState
          : [];
      let breedData =
        nextProps.contractsMonthlySalesData &&
        nextProps.contractsMonthlySalesData.breed
          ? nextProps.contractsMonthlySalesData.breed
          : [];
      let sourceDate =
        nextProps.contractsMonthlySalesData &&
        nextProps.contractsMonthlySalesData.source
          ? nextProps.contractsMonthlySalesData.source
          : [];
      let thisMonthContractInfo =
        nextProps.contractsMonthlySalesData &&
        nextProps.contractsMonthlySalesData.salesInformation
          ? nextProps.contractsMonthlySalesData.salesInformation
          : [];
      const financingMethods = config.financingPaymentMethods;
      // This will create sales information data (Bar chart)
      if (thisMonthContractInfo && thisMonthContractInfo.length > 0) {     
        let chartmonthlyData = Object.assign({}, this.state.chartmonthlyData);
        let yAxisContractTotal = [];
        let yAxisContractCount = [];
        let xAxis = [];
        let collectedContracts = [];
        let weeklyCountHeader = [];
        let weeklyCountHeaderData = {};
        thisMonthContractInfo.map((item) => {
          xAxis.push(`Week${item.weekCount}`);
          if (item.contracts) {
            yAxisContractCount.push(item.contracts.length);
            collectedContracts.push(item.contracts);
            let subCon = item.contracts;
            let total = 0;
            subCon.map((c) => {
              total = total + parseFloat(c.total);
            });
            yAxisContractTotal.push(total);
            weeklyCountHeader.push(
              { dataField : `Week${item.weekCount}`, text : `Week ${item.weekCount}`, sort : true, align : "right",
                headerStyle: () => {
                return { textAlign: "center" };
              }},
            );       
            weeklyCountHeaderData[`Week${item.weekCount}`] = item.contracts.length            
         
          }
        });
        chartmonthlyData.datasets[0].data = yAxisContractTotal;
        chartmonthlyData.labels = xAxis;
        this.setState({ chartmonthlyData, monthlyDataLoading: false, tableHeaderWeeklySalesCount : weeklyCountHeader, tableHeaderWeeklySalesCountData : [weeklyCountHeaderData] });
        if (collectedContracts && collectedContracts.length > 0) {
          let allCollectedContracts = collectedContracts.reduce(
            (a, b) => a.concat(b),
            [],
          );
          let total = 0,
            tax = 0,
            cash = 0,
            cb = 0,
            cfl = 0,
            other = 0;
          allCollectedContracts.map((c) => {
            if (c.total) {
              total = total + parseFloat(c.total);
            }
            if (c.tax) {
              tax = tax + parseFloat(c.tax);
            }
            if (c.ContractPayments) {
              c.ContractPayments.map((p) => {
                const indexOfFinancingMethod = p.PaymentType
                  ? financingMethods.indexOf(p.PaymentType.payment_type)
                  : -1;
                if (
                  (p.method === this.paymentType.credit_debit &&
                    p.PaymentType === null) ||
                  (p.PaymentType &&
                    p.PaymentType.payment_type &&
                    p.PaymentType.payment_type ===
                      this.paymentType.american_express) ||
                  (p.PaymentType &&
                    p.PaymentType.payment_type &&
                    p.PaymentType.payment_type === this.paymentType.discover)
                ) {
                  cb = cb + parseFloat(p.amount);
                } else if (
                  p.method === this.paymentType.other &&
                  p.PaymentType &&
                  p.PaymentType.payment_type &&
                  p.PaymentType.payment_type === this.paymentType.cash
                ) {
                  cash = cash + parseFloat(p.amount);
                } else if (
                  p.method === this.paymentType.other &&
                  indexOfFinancingMethod >= 0
                ) {
                  cfl = cfl + parseFloat(p.amount);
                } else {              
                  console.log('Unrecognized Payment method', p && p.PaymentType && p.PaymentType.payment_type ? p.PaymentType.payment_type: '');
                }
              });
            }
          });
          this.setState({
            monthlyTotal: total,
            monthlyTax: tax,
            monthlyCount: allCollectedContracts.length,
            monthlyCDTotal: cb,
            monthlyFinanceTotal: cfl,
            monthlyOtherTotal: other,
            monthlyCashTotal: cash,
          });
        }
      } else {
        this.resetState();
      }
      //this will create locations sales tables data
      if (locationData && locationData.length > 0) {
        let locationDataHeaderArray = [];

        locationData.forEach((subArray) => {
          let headerData = [];
          let columnDataObj = {};
          let columnData = [];

          subArray.forEach((obj) => {
            headerData.push({ dataField: obj.state, text: obj.state });
            columnDataObj[obj.state] = obj.contractCount;
          });
          columnData.push(columnDataObj);
          locationDataHeaderArray.push({ headerData, columnData });
        });
        this.setState({ salesLocationFullData: locationDataHeaderArray });
      }
      if (breedData && breedData.length > 0) {
        this.setState({ breedSalesData: breedData });
      } else {
        this.setState({ breedSalesData: [] });
      }
      if (sourceDate && sourceDate.length > 0) {
        this.setState({ sourceOfSalesData: sourceDate });
      } else {
        this.setState({ sourceOfSalesData: [] });
      }
    }

    if(this.props.contractsYearlySalesData !== nextProps.contractsYearlySalesData){  
      const amountData = nextProps.contractsYearlySalesData.salesInformationOther;    
      const contractCountData = nextProps.contractsYearlySalesData.contractCountViaStates;
      const sourceOfSalesData = nextProps.contractsYearlySalesData.sourceOfSales;
      const headerFirstObjAmountData = amountData && amountData.length > 0 ? amountData[0] :  [];
      const headerFirstcontractCountData = contractCountData && contractCountData.length > 0 ? contractCountData[0] : [];
      const headerSourceOfSales = sourceOfSalesData && sourceOfSalesData.length > 0 ? sourceOfSalesData[0] : [];
      let salesInformationAmountDataTempHeader = [];
      let salesInformationcontractCountDataTempHeader = [];
      let salesInformationSourceOfSalesTempHeader = [];
      for(let itemObj in headerFirstcontractCountData){   
        let headerobj = {};       
        if(itemObj == 'totalContractCount'){
            headerobj = {
                dataField : itemObj,
                text : 'Total Sales',                
                sort : true,
                align : 'right',     
                headerStyle: (selector, id) => {
                  return {  textAlign: "center" };
                }    
            }
        }else if(itemObj == 'Location'){
            headerobj = {
                dataField : itemObj,
                text : itemObj,
                sort : true,                        
            }
        } 
        else{
          headerobj = {
            dataField : itemObj,
            text : itemObj,
            sort : true,   
            align : 'right',
            headerStyle: (selector, id) => {
              return {  textAlign: "center" };
            }       
          }
        } 
        salesInformationcontractCountDataTempHeader.push(headerobj)  
      }
      for(let obj in headerFirstObjAmountData ){  
        let data ={};  
        if( obj == HEADERCOLUMN.category ){
         data = {
            dataField : obj,
            text : obj,
            sort : true,           
          };
        }else{
         data = {
            dataField : obj,
            text : obj,
            sort : true,
            align : 'right',
            headerStyle: (selector, id) => {
              return {  textAlign: "center" };
            } 

          };
        }
 
       salesInformationAmountDataTempHeader.push(data);
      }
      for(let itemObj in headerSourceOfSales){
        let data ={};
        if( itemObj == HEADERCOLUMN.source ){
         data = {
            dataField : itemObj,
            text : itemObj,
            sort : true, 
            formatter: (cell, row) => {
              return (
                <>
                <a
                  onClick={(e) => {
                    this.openSourceOfSalesYearlyDetailModal(e, row);
                  }}
                  style={{ cursor: "pointer", color: "#5867dd", fontWeight: "600" }}
                >
                  {cell}
                </a>
                <span className="ml-2"></span>
                { row.isUtmData &&        
                <span className="m-badge mx-auto my-0 px-1 m-badge--info">
                  <strong><small>UTM</small></strong> 
                </span>  
                } 
                </>
              );
            },          
          };
        }else if(itemObj == HEADERCOLUMN.contractCount){
          data = {
              dataField : itemObj,
              text : 'Total Sales',                
              sort : true,
              align : 'right',   
              headerStyle: () => {
                return {  textAlign: "center" };
              }      
          }
        }else if(itemObj == HEADERCOLUMN.isUtmData){
          data = {
              dataField : itemObj,
              text : 'Total Sales',                
              sort : true,
              hidden: true              
          }
        }else if(itemObj == HEADERCOLUMN.utmData){
          data = {
              dataField : itemObj,
              text : 'Total Sales',                
              sort : true,
              hidden: true              
          }
        }else{
          data = {
              dataField : itemObj,
              text : itemObj,
              sort : true,
              align : 'right',
              headerStyle: () => {
                return {  textAlign: "center" };
              } 
            };
        } 
       salesInformationSourceOfSalesTempHeader.push(data);
      }
      this.setState({
        salesInformationAmountData : amountData,
        contractCountDataYearly : contractCountData,
        sourceOfSalesDataYearly : sourceOfSalesData,
        tableHeadersalesInformationAmountData : salesInformationAmountDataTempHeader,
        tableHeadercontractCountDataYearly : salesInformationcontractCountDataTempHeader,
        tableHeaderSourceOfSales : salesInformationSourceOfSalesTempHeader,
        loadingYearlyData : false,
      });
    }

    if (
      nextProps.contractsMonthlySalesDataError &&
      this.props.contractsMonthlySalesDataError !==
        nextProps.contractsMonthlySalesDataError
    ) {
      NotificationManager.error(
        "An error occurred while loading the Contracts information",
      );
    }  

    if (
      nextProps.contractsYearlySalesDataError &&
      this.props.contractsYearlySalesDataError !==
        nextProps.contractsYearlySalesDataError
    ) {
      NotificationManager.error(
        "An error occurred while loading the Contracts sales information",
      );
    } 
  };

  render() {
    const {
      chartOptions,
      chartmonthlyData,
      monthlyTotal,
      monthlyCount,
      monthlyDataLoading,
      sourceOfSalesData,
      sourceOfSalesDetailsContract,
      salesSelectOptionYearly,
      salesSelectedOptionYearly,
      salesInformationAmountData,
      contractCountDataYearly,
      loadingYearlyData,
      tableHeaderWeeklySalesCount,
      tableHeaderWeeklySalesCountData,
      sourceOfSalesDataYearly,
      sourceOfSalesYearlyDetailsContract,
      selectedSourceYearly,
    } = this.state;

    const { petShop } = this.props;
    return (
      <div
        className="m-grid m-grid--hor m-grid--root m-page"
        style={{ minHeight: "100vh" }}
      >
        <div className="m-grid__item m-grid__item--fluid m-grid m-grid--hor-desktop m-grid--desktop m-body body-background">
          <div className="m-grid__item m-grid__item--fluid  m-grid m-grid--ver	m-container m-container--responsive m-container--xxl m-page__container">
            <div className="m-grid__item m-grid__item--fluid m-wrapper container">
              <div className="row">
                <div className="col-xl-6 col-md-12">
                  <div className="m-portlet m-portlet--bordered-semi m-portlet--full-height"  style={{ maxHeight: "360px", overflow: "auto" }}>
                    <div className="m-portlet__head">
                      <div className="m-portlet__head-caption">
                        <div className="m-portlet__head-title">
                          <h3 className="m-portlet__head-text">
                            Sales Information
                          </h3>
                        </div>
                      </div>

                      <div
                        style={{ width: "48%", margin: "0", marginTop: "10px" }}
                      >
                        <Select
                          options={this.state.salesSelectOption}
                          value={this.state.saleSelectedOption}
                          name="selectOption"
                          onChange={this.changeSalesOption}
                          placeholder="Select Sales Filter"
                        />
                      </div>
                    </div>
                    <div className="m-portlet__body">
                      <div className="row">
                        <div className="col-xl-10 col-md-6">
                          <div className="m-widget29">
                            <div className="m-widget14__chart">
                              {!monthlyDataLoading ? (                             
                                <BarChart
                                  data={chartmonthlyData}
                                  options={chartOptions}
                                  width="352"
                                  height="120"
                                  redraw
                                />                
                                ) : (
                                <div className={"loader-center"}>
                                  <Loader
                                    type="line-scale"
                                    active={true}
                                    size={25}
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-2 col-md-6">
                          {!monthlyDataLoading ? (
                            <>
                              <div className="row">
                                <div className="m-widget29">
                                  <div className="m-widget_content mb-0 pb-0">
                                    <h3 className="m-widget_content-title">
                                      Total Sale
                                    </h3>
                                    <div className="m-widget_content-items">
                                      <div className="m-widget_content-item">
                                        <span className="m--font-accent">
                                          ${this.formatCash(monthlyTotal)}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="m-widget29">
                                  <div className="m-widget_content mt-0 pt-0">
                                    <h3 className="m-widget_content-title">
                                      Total Puppies
                                    </h3>
                                    <div className="m-widget_content-items">
                                      <div className="m-widget_content-item">
                                        <span className="text-dark">
                                          {parseInt(monthlyCount)}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          ) : (
                            <div className={"loader-center"}>
                              <Loader
                                type="line-scale"
                                active={true}
                                size={25}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-xl-10 px-4">
                          <div className="row justify-content-center">
                            <div className="col-xl-11 ml-4 px-4">
                            <div className="m-widget29">
                            <div className="m-widget14__chart">
                              {!monthlyDataLoading && (                    
                                <ToolkitProvider 
                                  keyField= "Week1"                            
                                  data={tableHeaderWeeklySalesCountData}
                                  columns={tableHeaderWeeklySalesCount}                            
                                  search
                                  hover={true}
                                  filter={filterFactory()}
                                >
                                  {(props) => (
                                    <div>
                                      <BootstrapTable
                                        classes="petTable"
                                        {...props.baseProps}
                                      />
                                    </div>
                                  )}
                                </ToolkitProvider>
                              )}
                            </div>
                          </div>
                            </div>
                          </div>             
                        </div>                 
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-md-12">
                  <div
                    className="m-portlet m-portlet--full-height"
                    style={{ maxHeight: "360px", overflow: "auto" }}
                  >
                    <div className="m-portlet__head">
                      <div className="m-portlet__head-caption">
                        <div className="m-portlet__head-title">
                          <h3 className="m-portlet__head-text">Breeds</h3>
                        </div>
                      </div>
                    </div>
                    <div className="m-portlet__body">
                      <div className="row">
                        <div className="col-xl-12">
                        { this.state.breedSalesData && this.state.breedSalesData.length > 0 ?
                          <ToolkitProvider
                            keyField="breeed"
                            data={this.state.breedSalesData}
                            columns={this.tableHeaderbreedSalesData}
                            search
                            hover={true}
                            filter={filterFactory()}
                          >
                            {(props) => (
                              <div>
                                <BootstrapTable
                                  classes="petTable"
                                  {...props.baseProps}
                                />
                              </div>
                            )}
                          </ToolkitProvider>:
                          <span><strong>No Data Found</strong></span>
                         }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-md-12">
                  <div className="m-portlet m-portlet--full-height" style={{ maxHeight: "360px", overflow: "auto" }}>
                    <div className="m-portlet__head">
                      <div className="m-portlet__head-caption">
                        <div className="m-portlet__head-title">
                          <h3 className="m-portlet__head-text">
                            Source of Sale
                          </h3>
                        </div>
                      </div>
                    </div>
                    <div className="m-portlet__body">
                      <div className="row">
                        <div className="col-xl-12">
                        { sourceOfSalesData && sourceOfSalesData.length > 0 ?
                          <ToolkitProvider
                            keyField="state"
                            data={sourceOfSalesData}
                            columns={this.tableHeaderSalesOfSourceData}
                            search
                            hover={true}
                            filter={filterFactory()}
                          >
                            {(props) => (
                              <div>
                                <BootstrapTable
                                  classes="petTable"
                                  {...props.baseProps}
                                />
                              </div>
                            )}
                          </ToolkitProvider>:
                          <span><strong>No Data Found</strong></span>
                         }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>          
              </div>  
              <div className="row">
                 <div className="col-xl-12 col-md-12">							
                    <div className="m-portlet m-portlet--full-height" style={{ overflow: 'auto'}}>
                      <div className="m-portlet__head">                      
                        <div className="m-portlet__head-caption">
                          <div className="m-portlet__head-title">
                            <h3 className="m-portlet__head-text">
                              Sales Information
                            </h3>
                          </div>                          
                        </div>                                    
                        <div style={{width: "170px", margin: "0", marginTop: "10px"}}>                                                                                                                    
                          <Select
                            options={salesSelectOptionYearly}                                             
                            value ={salesSelectedOptionYearly}                                      
                            name="selectOption"
                            onChange={this.changeSalesOptionYearly}
                            placeholder="Select Sales Filter"                                  
                          />                                                                 
                        </div>                                 
                      </div>
                      <div className="m-portlet__body">             
                         { !loadingYearlyData ?
                        <div className="row">
                            <div className="col-xl-12">
                              <ToolkitProvider  
                                keyField="Category"                                      
                                data= {salesInformationAmountData}
                                columns={this.state.tableHeadersalesInformationAmountData}
                                search
                                hover={true}
                                filter={filterFactory()}
                            >
                            {props => (
                            <div>                                                              
                            <BootstrapTable
                              classes="petTable"
                              {...props.baseProps}                                                                                
                            />  
                            </div>
                             )}
                              </ToolkitProvider>
                            </div>                                
                        </div>:
                        <div className={"loader-center"}>
                          <Loader
                           type="line-scale"
                           active={true}
                           size={25}
                          />
                        </div>
                         }
                         { !loadingYearlyData ?
                        <div className="row">
                          <div className="col-xl-12">
                            <ToolkitProvider  
                              keyField="Location"                                      
                              data= {contractCountDataYearly}
                              columns={this.state.tableHeadercontractCountDataYearly}
                              search
                              hover={true}
                              filter={filterFactory()}
                            >
                            {props => (
                            <div>                                                              
                            <BootstrapTable
                              classes="petTable"
                              {...props.baseProps}
                                pagination={paginationFactory()}                                                     
                           />  
                            </div>
                            )}
                            </ToolkitProvider>
                          </div>
                        </div>:null                                            
                         }
                        { !loadingYearlyData && sourceOfSalesDataYearly && sourceOfSalesDataYearly.length > 0 ?
                        <div className="row">
                          <div className="col-xl-12">
                            <ToolkitProvider  
                              keyField="breeed"                                      
                              data= {sourceOfSalesDataYearly}
                              columns={this.state.tableHeaderSourceOfSales}
                              search
                              hover={true}
                              filter={filterFactory()}
                            >
                            {props => (
                            <div>                                                              
                            <BootstrapTable
                              classes="petTable"
                              {...props.baseProps}
                                pagination={paginationFactory()}                                                     
                           />  
                            </div>
                            )}
                            </ToolkitProvider>
                          </div>
                         </div>:null                                            
                          }
                      </div>
                    </div>
                  </div>`
              </div>

              {/* Source of sales details view modal start */}
              <div
                className="modal fade show"
                id="full_details_source_of_sale_modal"
                tabIndex="-1"
                role="dialog"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <form className="m-form">
                      <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">
                          {this.state.selectedSource}
                        </h5>
                        <button
                          type="button"
                          className="close"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">×</span>
                        </button>
                      </div>
                      <div className="modal-body">
                        <div className="row">
                          <div className="col-xl-12">
                            <ToolkitProvider
                              keyField="state"
                              data={sourceOfSalesDetailsContract}
                              columns={ this.tableHeaderSourceOfSalesDetailColumnData}
                              search
                              hover={true}
                              filter={filterFactory()}
                            >
                              {(props) => (
                                <div>
                                  <BootstrapTable
                                    classes="petTable"
                                    {...props.baseProps}
                                  />
                                </div>
                              )}
                            </ToolkitProvider>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              {/*  Source of sales details view modal end */}   

            {/* Source of sales yearly details view modal start */}
              <div
                className="modal fade show"
                id="full_details_yearly_source_of_sale_modal"
                tabIndex="-1"
                role="dialog"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <form className="m-form">
                      <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">
                          {this.state.selectedSourceYearly}
                        </h5>
                        <button
                          type="button"
                          className="close"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">×</span>
                        </button>
                      </div>
                      <div className="modal-body">
                        <div className="row">
                          <div className="col-xl-12">
                            <ToolkitProvider
                              keyField="state"
                              data={sourceOfSalesYearlyDetailsContract}
                              columns={ this.tableHeaderSourceOfSalesDetailColumnData}
                              search
                              hover={true}
                              filter={filterFactory()}
                            >
                              {(props) => (
                                <div>
                                  <BootstrapTable
                                    classes="petTable"
                                    {...props.baseProps}
                                  />
                                </div>
                              )}
                            </ToolkitProvider>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              {/*  Source of sales yearly details view modal end */}     
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.cognito.user,
  contractsMonthlySalesData: state.salesDashBoardReducer.contractsMonthlySalesData,
  contractsMonthlySalesDataError: state.salesDashBoardReducer.contractsMonthlySalesDataError,
  contractsYearlySalesData : state.salesDashBoardReducer.contractsYearlySalesData,
  contractsYearlySalesDataError :  state.salesDashBoardReducer.contractsYearlySalesDataError,
  petShop: state.petShopReducer.currentPetshop,
});
const mapDispatchToProps = (dispatch) => ({

  getCurrentPetShop: (t) => {
    dispatch(getCurrentPetShop(t));
  },
  getMonthlySalesPromotionInfo: (startDate) => {
    dispatch(getMonthlySalesPromotionInfo(startDate));
  },
  getYearlySalesPromotionInfo: (type,start_date) => {
    dispatch(getYearlySalesPromotionInfo(type,start_date));
  }
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AdminDashboard),
);
